import React, { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'

import useJurisdiction from '../../utils/Jurisdiction'

export default function RitInfoToggle({ info, progress }) {
	const [hidden, setHidden] = useState(true)
	const { jurisdiction } = useJurisdiction()

	const visibleStyle = {
		display: 'block',
	}
	const hiddenStyle = {
		display: 'none',
	}

	return (
		<div className='info-Container'>
			<div className='info-Border'>
				<div className='info-Text'>
					{progress === 3 && jurisdiction === 'IFRS 16'
						? ReactHtmlParser(info.infoAbbreviatedIFRS)
						: (progress === 3 && jurisdiction === 'GASB 62') ||
						  (progress === 3 && jurisdiction === 'GASB 87')
						? ReactHtmlParser(info.infoAbbreviatedGASB)
						: progress === 3 && jurisdiction === 'ASC 840'
						? ReactHtmlParser(info.infoAbbreviatedASC840)
						: progress === 3 && jurisdiction === 'ASC 842'
						? ReactHtmlParser(info.infoAbbreviatedASC842)
						: ReactHtmlParser(info.infoAbbreviated)}

					{info.infoExpanded && (
						<>
							<br />
							<button
								className='info-Button'
								onClick={() => setHidden(!hidden)}
								style={hidden ? visibleStyle : hiddenStyle}
							>
								See More
							</button>
						</>
					)}
				</div>
				<div style={hidden ? hiddenStyle : visibleStyle} className='info-Text'>
					{ReactHtmlParser(info.infoExpanded)}
					<br />
					<br />
					<button className='info-Button' onClick={() => setHidden(!hidden)}>
						See Less
					</button>
				</div>
			</div>
		</div>
	)
}
